/**
 * Plain base64 encode/decode for transporting content-addressed chunk bytes as JSON string values
 * between the browser (`src/integration/bim-hub-model-storage.ts`, `main.ts`) and the Workbench BFF
 * (`src/server/d3-save.ts`). Not base64url: nothing here becomes part of a URL, and a JSON string
 * value has no problem holding `+` / `/` / `=`.
 *
 * Deliberately duplicated in spirit, not in code, from `functions/_identity.ts`'s
 * `bytesToBase64Url`/`base64UrlToBytes` -- that pair is base64url-specific (URL/cookie transport)
 * and lives in the BFF-only `functions/` tree, which is not on this app's `src/` import graph.
 *
 * Uses the classic `String.fromCharCode` chunked loop rather than `btoa(String.fromCharCode(...bytes))`
 * spread, which blows the JS engine's argument-count limit on large payloads.
 */
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  const chunkSize = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    const chunk = bytes.subarray(offset, offset + chunkSize);
    binary += String.fromCharCode(...chunk);
  }
  return btoa(binary);
}

export function base64ToBytes(value: string): Uint8Array {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
}
